<template>
  <div class="allOrder-view">
    <!-- <el-checkbox v-model="checked">全选</el-checkbox> -->
    <list-data
    :dataList="dataList"
    @operation="operation"
    @handleCurrentChange="handleCurrentChange"
    :pages="pages"
    ></list-data>
    <el-dialog
      title="物流信息"
      :visible.sync="dialogVisible"
      width="30%">
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <p>{{ item.AcceptTime }}</p>
          <p>{{ item.AcceptStation }}</p>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import List from './list'
import Axios from 'axios'
export default {
  name: '',
  components: {
    'list-data': List
  },
  data () {
    return {
      checked: true,
      dialogVisible: false,
      pages: {
        size: 10,
        start: 0,
        total: 0
      },
      dataList: [],
      list: []
    }
  },
  methods: {
    operation (par) {
      const type = par.type
      switch (type) {
        case 'pay':
          alert('zf')
          break
        case 'details':
          this.$router.push({
            name: 'OrderDetails1',
            query: par.row
          })
          break
        case 'cancel':
          this.$confirm('是否取消该订单？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            this.deleteOrder(par.row.id)
          }).catch(() => {})
          break
        case 'track':
          this.getExpress(par.row.shipperCode, par.row.logisticsNo)
          // this.getExpress('ZTO', '265400200427')
          break
        case 'qr':
          this.$confirm('是否确认收货？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            this.userConfirmOrder(par.row.id)
          }).catch(() => {})
          break
        default:
          break
      }
    },
    deleteOrder (id) {
      Axios.post(this.$allUrl.deleteOrder, {
        orderId: id
      }, {
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.code === '0') {
          this.$message({
            message: '取消订单成功！',
            type: 'success'
          })
          this.pages.start = 0
          this.getOrderList()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleCurrentChange (page) {
      this.pages.start = (page - 1) * this.pages.size
      this.getOrderList()
    },
    getOrderList () {
      const userId = this.$store.state.userMsg.id
      let par = {
        userId: userId,
        start: this.pages.start,
        length: this.pages.size,
        type: 3
      }
      Axios.post(this.$allUrl.getOrderList, par, {
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.code === '0') {
          this.pages.total = res.recordsTotal
          let list = res.data
          this.dataList = []
          list.forEach(e => {
            this.dataList.push({
              id: e.id,
              orderNum: e.orderNo,
              time: e.createTime,
              imgUrl: e.orderDetailList[0].coverUrl,
              name: e.orderDetailList[0].bookName,
              money: e.payAmount,
              state: e.status,
              stateText: this.getText(e.status),
              payType: 'zfb',
              list: JSON.stringify(e.orderDetailList),
              consignee: e.consignee,
              tel: e.tel,
              address: e.address,
              logisticsNo: e.logisticsNo,
              shipperCode: e.shipperCode
            })
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getText (status) {
      let text = ''
      switch (status) {
        case 0:
          text = '待支付'
          break
        case 1:
          text = '完成'
          break
        case 2:
          text = '待发货'
          break
        case 3:
          text = '已发货'
          break
        default:
          break
      }
      return text
    },
    userConfirmOrder (id) {
      const userId = this.$store.state.userMsg.id
      let par = {
        orderId: id,
        userId: userId
      }
      Axios.post(this.$allUrl.userConfirmOrder, par, {
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.code === '0') {
          this.getOrderList()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getExpress (shipperCode, logisticCode) {
      let par = {
        shipperCode: shipperCode,
        logisticCode: logisticCode
      }
      Axios.post(this.$allUrl.getExpress, par, {
        transformRequest: [function (data) {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        }],
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        if (res.code === '0') {
          this.dialogVisible = true
          this.list = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    this.getOrderList()
  }
}
</script>
<style lang="less" scoped>
  .allOrder-view{
    margin-top: 20px;
    margin-bottom: 50px;
    .allOrder-data{
      list-style: none;
    }
    .mergePay{
      float: right;
      border: 0;
      padding: 5px 20px;
      background-color: white;
      outline: none;
      cursor: pointer;
      background-color: #b60e0e;
        color: white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/MyOrder/waitSh.vue


// WEBPACK FOOTER //
// src/components/Personal/MyOrder/waitSh.vue